// extracted by mini-css-extract-plugin
export default {"box":"total_box__rZX8K","link":"total_link__AOeN+"};